import { render, staticRenderFns } from "./pandaDataStatistic.vue?vue&type=template&id=15905114&scoped=true"
import script from "./pandaDataStatistic.vue?vue&type=script&lang=ts"
export * from "./pandaDataStatistic.vue?vue&type=script&lang=ts"
import style0 from "./pandaDataStatistic.vue?vue&type=style&index=0&id=15905114&prod&lang=stylus&scoped=true"
import style1 from "./pandaDataStatistic.vue?vue&type=style&index=1&id=15905114&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15905114",
  null
  
)

export default component.exports